import React, { useState, useEffect, useRef, useContext } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ContentWrapper from "styles/contentWrapper"
import embeddingImg from "content/embedding/hero/embedding.png"

const miniSpot = "https://hrflow-ai.imgix.net/backgrounds/secondary-spot-mini.svg"
const bigSpot = "https://hrflow-ai.imgix.net/backgrounds/secondary-spot-big.svg"
const arrowIcon = "https://hrflow-ai.imgix.net/arrow.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
/*   background: ${({ theme }) => theme.colors.white};
  background-image:  url(${bigSpot}), url(${miniSpot});
  background-repeat: no-repeat;
  background-size: 31rem 29rem, 3.9rem 3.4rem;
  background-position: 5% 0%; */
  .item__inner {
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
  }
  padding: 0;
  .section-title {
    max-width: 50rem;
    margin: auto;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 1.75rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 2.5rem;
      line-height: 3rem;
    }
  }
  .section-subtitle {
    max-width: 50rem;
    margin: auto;
    margin-bottom: 2rem;
    text-align: center;
    font-size: 1.2rem;
    span {
      font-weight: 600;
    }
  }

  h3 {
    margin-bottom: 0;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
    h2 {
      padding: 0;
    }
    .inner-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .logo {
      margin-bottom: 1rem;
    }

    .text-content {
      width: 100%;
      max-width: 34rem;
      width: 100%;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 34rem;
      }
      h2 {
        span {
          color: ${({ theme }) => theme.colors.secondary}
        }
      }
      p {
        font-family: ${({ theme }) => theme.fonts.plainLight};
      }
      .author {
        font-weight: 600;
      }
    }
    .image-content {
      width: 100%;
  /*     max-width: 40rem;
      margin-top: 4rem; */
      margin-left: 0;
      .hidden {
        display: none;
      }
      .motion {
        .resized {
          width: 60%;
          margin: auto;
        }
        img {
          width: 80%;
        }
      }
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        margin-left:  ${props => props.reversed ? '5rem' : '0' };
        margin-right:  ${props => props.reversed ? '0' : '5rem' };
        margin-top: 5rem;
      }
    }
    .about-author {
      border-radius: ${({ theme }) => theme.borderRadius};
      box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.16);
      filter: grayscale(20%) contrast(1) brightness(90%);
      transition: all 0.3s ease-out;
      &:hover {
        filter: grayscale(50%) contrast(1) brightness(90%);
        transform: translate3d(0px, -0.125rem, 0px);
        box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.32);
      }
    }
  }
`
const StyledCard = styled.div`
  background: #FFFFFF;
  box-shadow: -5px 4px 14px rgba(100, 133, 168, 0.09), 0px 11px 55px rgba(30, 52, 92, 0.058);
  border-radius: 6px;
  padding: 1rem;
  max-width: 34rem;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 34rem;
  }
`

const StyledDropDown = styled.div`
  border-bottom: 1px solid #DBE7F4;
  cursor: pointer;
  .dropdown__header {
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .dropdown__title {
      font-size: 1.2rem;
      line-height: 1.3rem;
      color: #9FB1C5;
      .logo-wrapper {
        height: 1.5rem;
        width: 1.5rem;
        margin-right: 1rem;
        display: none;
      }
      display: flex;
      justify-content: flex-start;
    }
    .dropdown__arrow {
      background-image: url(${arrowIcon});
      background-position: center;
      background-size: 1rem 1rem;
      background-repeat: no-repeat;
      width: 1rem;
      height: 1rem;
      margin-left: 1rem;
      transition: all 0.3s ease-in-out;
    }
  }
  .dropdown__body {
    color: #6485A8;
    font-size: 0.9rem;
    line-height: 1.3rem;
    display: none;
    a {
      color: #9FB1C5;
      img {
        height: 0.6rem;
        width: auto;
        margin-left: 0.7rem;
      }
      a:hover {
        opacity: 0.8;
      }
    }
  }
  &.shown {
    padding: 1rem;
    background: #F4FAFF;
    .dropdown__header {
      padding-top: 0;
      padding-bottom: 0;
      .dropdown__title {
        color: #0F2D4D;
        .logo-wrapper {
          display: block;
        }
      }
      .dropdown__arrow {
        transform:rotate(90deg);
      }
    }
    .dropdown__body {
      display: block;
    }
  }

`

const Automate = ({ content }) => {
  const { frontmatter, exports } = content[0].node
  const { shownItems, items } = exports
  /* const [shownPositions, setShownPositions] = useState(shownItems) */
  const [openedIndex, setOpendIndex] = useState(0)
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.amazonaws.com/img.riminder.net/animations/parsing-animation.js";
    script.async = true;
    document.body.appendChild(script);
    
    const scriptRevealing = document.createElement("script");
    scriptRevealing.src = "https://s3.amazonaws.com/img.riminder.net/animations/revealing-animation.js";
    scriptRevealing.async = true;
    document.body.appendChild(scriptRevealing);

    const scriptSearching = document.createElement("script");
    scriptSearching.src = "https://s3.amazonaws.com/img.riminder.net/animations/searching-animation.js";
    scriptSearching.async = true;
    document.body.appendChild(scriptSearching);

    const scriptScoring = document.createElement("script");
    scriptScoring.src = "https://s3.amazonaws.com/img.riminder.net/animations/scoring-animation.js";
    scriptScoring.async = true;
    document.body.appendChild(scriptScoring);

    const scriptReasoning = document.createElement("script");
    scriptReasoning.src = "https://s3.amazonaws.com/img.riminder.net/animations/reasoning-animation.js";
    scriptReasoning.async = true;
    document.body.appendChild(scriptReasoning);
  }, [])
  console.log('openedIndex', openedIndex)
  const image = getImage(frontmatter.logo)
  return (
    <StyledSection id="Automate">
      <StyledContentWrapper className="item__inner" revresed="true">
      <div className="inner-wrapper" revresed="true">
          <GatsbyImage
            className="logo"
            image={image}
            alt="flag logo"
          />
          <div className="text-content">
            <h2 className="mb-2">{frontmatter.title}</h2>
            <p>{frontmatter.description}</p>
          </div>
          <StyledCard>
            {items.map(({title, logo, text, link}, key) => {
               const Class = openedIndex === key ? "shown" : ""
               const img = getImage(logo)
              return (
                <StyledDropDown className={Class} onClick={() => setOpendIndex(key)}>
                  <div className="dropdown__header">
                    <span className="dropdown__title">
                      <span className="logo-wrapper">
                        <GatsbyImage
                          image={img}
                          alt={title}
                        />
                      </span>
                      <span>{title}</span>
                    </span>
                    <span className="dropdown__arrow"></span>
                  </div>
                  <div className="dropdown__body">
                    <p>{text}</p>
                    <Link to={link}><span>Learn more</span><img src={arrowIcon} alt="arrow link" /></Link>
                  </div>
                  
                </StyledDropDown>
              )
            })}
          </StyledCard>
        </div>
        <div className="image-content">
          {items.map((item, index) => {
            const klass = (openedIndex !== index ) ? 'hidden motion' : 'motion'
            return (
              <>
                {item.animation ? (
                  <div className={klass}>
                    <div id={item.animation} className={openedIndex > 0 && 'resized'}></div>
                  </div>
                )
                :
                (
                  <div className={klass}>
                    <img
                      src={embeddingImg}
                      alt="Embedding image"
                      layout="constrained"
                      width={400}
                    />
                  </div>
                )}
              </>
            )
          })}
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

export default Automate
